import React, { useState } from "react";
// Instead of: import axios from "axios";
// Use the custom instance:
import instance from "../../axios";

// If your component receives a prop `eventId`:
interface DownloadExcelButtonProps {
  eventId: number | string; // or whatever type it is
}

const DownloadExcelButton: React.FC<DownloadExcelButtonProps> = ({
  eventId,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      // 1. Fetch the file as a Blob using the custom instance
      const response = await instance.get(`/Admin/Orders/ExportOrdersXLSX`, {
        params: { IdEvent: eventId },
        responseType: "arraybuffer", // important to get a binary file
      });

      // 2. Convert to a Blob
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 3. Create a temporary URL
      const url = window.URL.createObjectURL(blob);

      // 4. Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Reservation data.xlsx");

      // 5. Trigger download
      document.body.appendChild(link);
      link.click();

      // 6. Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the Excel file:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="menu-button text-base rounded-2xl mb-2 !p-4"
      onClick={handleDownload}>
      {loading ? "Downloading..." : "Download Excel"}
    </button>
  );
};

export default DownloadExcelButton;
